import { useState } from 'react';
import { SearchInputWithOptions } from './SearchInput/search-input-with-options';
import {
  MapSearchResultFeature,
  MapSearchResult,
} from './SearchInput/map-types';
import { BorderType } from "grommet/utils";
import { Notification } from 'grommet';

const GEOCODING_DEFAULT_TYPES = [
  'region',
  'district',
  'place',
  'locality',
  'neighborhood',
  'address',
  'postcode',
];

export type HeaderSearchType = {
  initialValue?: string;
  hint?: string;
  searchDataTypes?: [string];
  setSearchInput?: (value: ((prevState: string) => string) | string) => void;
  addressSelectedNameCallback?: (
    value: ((prevState: string) => string) | string,
    stateShortCode: string,
  ) => void;
  addressSelectedBBoxCallback?: (position: number[]) => void;
  button?: boolean;
  border?: BorderType;
  height?: string;
  width?: string;
};

export type MapCompleteType = {
  label: JSX.Element;
  value: MapSearchResultFeature;
};

export const AddressSearchComponent = ({
  initialValue,
  hint,
  searchDataTypes,
  setSearchInput,
  addressSelectedNameCallback,
  addressSelectedBBoxCallback,
  button,
  border,
  height,
  width
}: HeaderSearchType): JSX.Element => {
  const searchAddress = async (
    query: string,
  ): Promise<MapSearchResult | undefined> => {
    const MAPBOX_KEY = process.env['REACT_APP_MAP_BOX_KEY']
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${'' + MAPBOX_KEY
      }&types=${searchDataTypes?.join(',') ?? GEOCODING_DEFAULT_TYPES.join(',')
      }&autocomplete=true&country=us`;
    try {
      const response = await fetch(url);
      return await response.json();
    } catch (error) {
      console.error(error);
      return undefined;
    }
  };
  const [args, setArgs] = useState<{
    options: MapSearchResultFeature[] | undefined;
    hint: string;
  }>({
    options: [],
    hint: hint ?? 'Search for county, zip code, town...',
  });

  const [showError, setShowError] = useState(false);

  const inputCallback = async (value: string) => {
    if (!value) {
      if (addressSelectedNameCallback) {
        addressSelectedNameCallback('', '');
      }
      return;
    }
    if (initialValue === value) {
      return;
    }
    const result = await searchAddress(value);
    if (result?.features?.length === 0) {
      setShowError(true);
    }
    setArgs((state) => {
      const tempAddressResult = { ...state };
      tempAddressResult.options = result?.features;
      return tempAddressResult;
    });
  };
  const onSelectOptionCallback = (
    bbox: number[],
    placeName: string,
    context: any[],
  ) => {
    if (addressSelectedNameCallback) {
      const stateShortCode =
        context
          .find((item) => item.id.indexOf('region') !== -1)
          ?.short_code.split('-')
          .pop() ?? '';
      addressSelectedNameCallback(placeName, stateShortCode);
    }
    if (addressSelectedBBoxCallback) addressSelectedBBoxCallback(bbox);
  };
  return (
    <>
      {showError && (
        <Notification
          toast
          status={'critical'}
          title="Error"
          message="Location entered is either incorrect or outside USA."
          onClose={() => setShowError(false)}
        />
      )}
      <SearchInputWithOptions
        {...args}
        initialValue={initialValue}
        setSearchInput={setSearchInput}
        inputCallback={inputCallback}
        onSelectOptionCallback={onSelectOptionCallback}
        button={button}
        border={border}
        height={height}
        width={width}
      />
    </>

  );
};
